import { useMemo } from 'react';
import type { GlobalNavProps } from './GlobalNav.types';
import {
  CLEVER_CLINIC_MARKETING_URL,
  CLEVER_PATIENTS_MARKETING_URL,
  HEALTHXCHANGE_ACADEMY_URL,
  HEALTHXCHANGE_DEVICES_MARKETING_URL,
  HEALTHXCHANGE_EPHARMACY_URL,
  HEALTHXCHANGE_SITE_URL,
} from 'app-core';

const useGlobalNavLinks = ({
  activeLink,
  isMobile = false,
}: {
  activeLink: GlobalNavProps['activeLink'];
  isMobile?: boolean;
}) => {
  const globalNavLinks = useMemo(() => {
    const LINK_DATA = [
      { name: 'Shop', href: HEALTHXCHANGE_EPHARMACY_URL, active: activeLink === 'shops' },
      {
        name: 'Education',
        href: HEALTHXCHANGE_ACADEMY_URL,
        active: activeLink === 'education',
      },
      {
        name: 'Devices',
        href: HEALTHXCHANGE_DEVICES_MARKETING_URL,
        active: activeLink === 'devices',
      },
      {
        name: 'Software',
        href: '',
        active: activeLink === 'software',
      },
      { name: 'Group', href: HEALTHXCHANGE_SITE_URL, active: activeLink === 'groups' },
    ];

    // for mobile view, add Clever Clinic and Clever Patients links
    if (isMobile) {
      LINK_DATA.push(
        {
          name: 'Clever Clinic',
          href: CLEVER_CLINIC_MARKETING_URL,
          active: false,
        },
        {
          name: 'Clever Patients',
          href: CLEVER_PATIENTS_MARKETING_URL,
          active: false,
        },
      );
    }

    return LINK_DATA;
  }, [activeLink, isMobile]);

  return globalNavLinks;
};

export default useGlobalNavLinks;
